import BaseService from "./BaseService";

export default class TermoService extends BaseService {

    constructor(self) {
        super(self);
    }

    ListarTermos(codigoAluno) {
        return this.ExecutaFetch("/api/Termo/ListarTermos/?codigoAluno=" + codigoAluno, "GET");
    }

    RecuperarConteudo(codigoTermoAluno) {
        return this.ExecutaFetch("/api/Termo/RecuperarConteudo/?codigoTermoAluno=" + codigoTermoAluno, "GET");
    }
}